import { render, staticRenderFns } from "./statusBlock.vue?vue&type=template&id=e2819220&"
import script from "./statusBlock.vue?vue&type=script&lang=js&"
export * from "./statusBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports